class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input.js-header-search-input');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.popularCategories = document.querySelector('.js-header-popular-categories');
    this.searchContainer = document.querySelector('.js-header-search');
    this.searchClose = document.querySelectorAll('.js-search-close, .js-search-background-close');
    this.openSearchBtn = document.querySelectorAll('.js-open-search');

    this.openSearchBtn.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleSearchContainerClass(true);
        setTimeout(() => this.input.focus(), 100);
      });
    });

    this.searchClose.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleSearchContainerClass(false);
      });
    });

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.getSearchTitle();
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&limit=10`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        if (typeof initializeObservers === 'function') initializeObservers();
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.popularCategories.style.display = 'none';
    this.predictiveSearchResults.style.display = 'block';
    this.predictiveSearchResults.classList.add('active');
  }

  close() {
    this.popularCategories.style.display = 'block';
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.classList.remove('active');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  toggleSearchContainerClass(isActive) {
    if (this.searchContainer) {
      if (isActive) {
        this.searchContainer.classList.add('display');
        if (window.lenis) {
          window.lenis.stop();
        } else {
          document.body.style.overflow = 'hidden';
        }
        setTimeout(() => {
          this.searchContainer.classList.add('active');
        }, 50);
      } else {
        this.searchContainer.classList.add('deactivate');
        setTimeout(() => {
          this.searchContainer.classList.remove('display', 'active', 'deactivate');
          if (window.lenis) {
            window.lenis.start();
          } else {
            document.body.style.overflow = 'visible';
          }
        }, 300);
      }
    }
  }

  getSearchTitle() {
    const searchNumberEl = document.querySelector('.js-search-number');
    const searchTitleTarget = document.querySelector('.js-get-search-title');

    if (searchNumberEl && searchTitleTarget) {
      const text = searchNumberEl.innerText.trim();

      const match = text.match(/^([IVXLCDM]+\.?)\s*(.+)$/i);

      if (match) {
        const [, numberWithDot, restText] = match;
        searchTitleTarget.innerHTML = `${numberWithDot} <u>${restText.trim()}</u>`;
      } else {
        searchTitleTarget.innerHTML = `<u>${text}</u>`;
      }
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);